import { RoleBusiness, RoleBusinessInput } from '../../model/role/RoleBusiness';
import i18n from "../../i18n";

const API_URL = process.env.REACT_APP_BUSINESS_SERVICE_BASE_URL || '';

const ROLE_BUSINESS_FIELDS = `
    id
    businessId
    name
    permissions {
        id
        permissionId
        permissionKey
        selectedOption
        isActive
    }
`;

async function gqlPost<T>(token: string, query: string, variables?: object): Promise<T> {
    const res = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, "Accept-Language": i18n.language || "pt",
        },
        body: JSON.stringify({ query, variables }),
    });
    const json = await res.json();
    if (json.errors) {
        const msg = json.errors.map((e: { message: string }) => e.message).join(', ');
        throw new Error(msg);
    }
    return json.data as T;
}

/** Per-business roles with their permission matrix. */
export async function getBusinessRoles(
    businessId: number | string,
    token: string
): Promise<RoleBusiness[]> {
    const data = await gqlPost<{ businessRoles: RoleBusiness[] | null }>(
        token,
        `query businessRoles($businessId: ID!) {
            businessRoles(businessId: $businessId) { ${ROLE_BUSINESS_FIELDS} }
        }`,
        { businessId }
    );
    return data.businessRoles ?? [];
}

export async function saveBusinessRole(
    input: RoleBusinessInput,
    token: string
): Promise<RoleBusiness> {
    const data = await gqlPost<{ saveBusinessRole: RoleBusiness }>(
        token,
        `mutation saveBusinessRole($input: RoleBusinessInput!) {
            saveBusinessRole(input: $input) { ${ROLE_BUSINESS_FIELDS} }
        }`,
        { input }
    );
    return data.saveBusinessRole;
}

export async function deleteBusinessRole(
    businessId: number | string,
    roleId: number | string,
    token: string
): Promise<boolean> {
    const data = await gqlPost<{ deleteBusinessRole: boolean }>(
        token,
        `mutation deleteBusinessRole($businessId: ID!, $roleId: ID!) {
            deleteBusinessRole(businessId: $businessId, roleId: $roleId)
        }`,
        { businessId, roleId }
    );
    return !!data.deleteBusinessRole;
}
